import React, { useState } from 'react';
import { Card, Button, Nav } from 'react-bootstrap';
import { Link, useRouteMatch, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWaveSquare,
  faMagic,
  faMusic,
  faRobot,
  faGuitar,
  faPenNib,
  faQuestionCircle,
  faBars,
  faTimes,
  faHome
} from "@fortawesome/free-solid-svg-icons";
import { useMediaQuery } from "react-responsive";
import '../components/components.css';

const ToolsMenu = () => {
  console.log("[RENDER TOOLS MENU]")

  const { url } = useRouteMatch();
  const location = useLocation();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1024px)" });
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Function to check if a route is active
  const isActiveRoute = (itemPath) => {
    if (itemPath === url) {
      return location.pathname === url;
    }
    return location.pathname.startsWith(itemPath);
  };

  // Simplified tool list
  const tools = [
    {
      label: "Music ID",
      icon: faMusic,
      to: `${url}/music-identification`,
      description: "Identify songs"
    },
    {
      label: "AI Stems",
      icon: faWaveSquare,
      to: `${url}/ai-stems-separator`,
      description: "Separate tracks"
    },
    {
      label: "Auto Master",
      icon: faMagic,
      to: `${url}/auto-mastering`,
      description: "AI mastering"
    },
    {
      label: "Voice AI",
      icon: faRobot,
      to: `${url}/ai-voice-changer`,
      description: "Transform vocals"
    },
    {
      label: "Beats & Chords",
      icon: faGuitar,
      to: `${url}/beats-chords`,
      description: "Generate music"
    },
    {
      label: "Lyrics AI",
      icon: faPenNib,
      to: `${url}/lyrics-ai`,
      description: "Generate lyrics"
    },
    {
      label: "Help",
      icon: faQuestionCircle,
      to: `${url}/help`,
      description: "Get support"
    }
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const MenuContent = () => (
    <div className="tools-menu-content">
      <Nav className="flex-column">
        {tools.map((tool) => {
          const isActive = isActiveRoute(tool.to);
          return (
            <Nav.Link
              key={tool.to}
              as={Link}
              to={tool.to}
              className={`tools-menu-item ${isActive ? 'active' : ''}`}
              onClick={() => isTabletOrMobile && setIsMenuOpen(false)}
            >
              <div className="d-flex align-items-center">
                <FontAwesomeIcon
                  icon={tool.icon}
                  className="me-3"
                  style={{ 
                    color: isActive ? '#ffffff' : 'rgba(255, 255, 255, 0.7)',
                    fontSize: 'var(--font-md)',
                    width: '16px'
                  }}
                />
                <div className="flex-grow-1 overflow-hidden">
                  <div 
                    className="tool-name"
                    style={{
                      color: isActive ? '#ffffff' : 'rgba(255, 255, 255, 0.85)',
                      fontWeight: isActive ? '600' : 'normal',
                      fontSize: 'var(--font-base)'
                    }}
                  >
                    {tool.label}
                  </div>
                  {!isTabletOrMobile && (
                    <div 
                      className="tool-description"
                      style={{
                        color: 'rgba(255, 255, 255, 0.6)',
                        fontSize: 'var(--font-sm)',
                        lineHeight: '1.2',
                        marginTop: '2px'
                      }}
                    >
                      {tool.description}
                    </div>
                  )}
                </div>
              </div>
            </Nav.Link>
          );
        })}
      </Nav>
    </div>
  );

  if (isTabletOrMobile) {
    return (
      <div className="mobile-tools-menu-container">
        <Button
          variant="outline-light"
          size="sm"
          onClick={toggleMenu}
          className="beats-btn-outline"
        >
          <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} className="me-2" />
          Tools
        </Button>
        
        {isMenuOpen && (
          <div className="mobile-tools-menu-overlay">
            <Card className="beats-card mobile-tools-menu">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="mb-0" style={{ color: '#d9d9d9' }}>Tools & Features</h6>
                  <Button
                    variant="link"
                    className="p-0"
                    onClick={toggleMenu}
                    style={{ color: 'rgba(255, 255, 255, 0.7)' }}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </Button>
                </div>
                <MenuContent />
              </Card.Body>
            </Card>
          </div>
        )}
      </div>
    );
  }

  // Desktop Menu
  return (
    <div className="desktop-tools-menu">
      <Card className="beats-card tools-menu-card h-100">
        <Card.Body className="p-3">
          <h6 className="mb-3 text-center" style={{ color: '#d9d9d9', fontSize: 'var(--font-base)' }}>
            Tools & Features
          </h6>
          <MenuContent />
        </Card.Body>
      </Card>
    </div>
  );
};

export default ToolsMenu; 